import CollectionView from 'core/src/views/base/collection-view';
import NotificationItemView from 'core/src/views/item-views/notification-item-view';

const NotificationCollectionView = CollectionView.extend({
  itemView: NotificationItemView,
});

export default NotificationCollectionView;

